import { CollectionModelFieldAnchor } from '@ikegps/core-shared';
import { Translate } from '../../i18n';
import { m } from '../../mithril';
import type { MithrilVNode } from '../../mithril';
import type { ICollectionViewController } from '../../modules/collection.view/collection.view.ctrl.interface';
import { addStyles } from '../theme';
import { AnchorInputState } from './anchor.input.state';
import { CSS, Style } from './anchor.input.style';
import { BearingInput } from './bearing.input';
import { DistanceInput } from './distance.input';
import { SelectInputComponent } from './input.select';

addStyles(Style);

export const AnchorInput = {
	view(state: AnchorInputState, ctrl: ICollectionViewController, field: CollectionModelFieldAnchor): MithrilVNode {
		return m(
			'div',
			{
				className: CSS.container,
				onclick: (e) => ctrl.selectAnchorField(e, field),
			},
			[
				SelectInputComponent.view(state.placement),
				m(
					'div',
					{
						className: CSS.relatedSpans,
					},
					[SelectInputComponent.view(state.relatedSpans[0]), SelectInputComponent.view(state.relatedSpans[1])]
				),
				m('div', { className: CSS.inputs }, [
					m('div', { className: CSS.leftInput }, DistanceInput.view(state.distance)),
					m('div', { className: CSS.rightInput }, BearingInput.view(state.bearing)),
				]),
				state.hasError() ? m('span', { className: CSS.MDL.error + ' ' + CSS.error }, Translate(state.error)) : null,
			]
		);
	},
};
